import $ from "jquery";
import "popper.js/dist/popper.js";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel";
//import 'hammerjs/hammer.js';
import debounce from "lodash.debounce";

import Vue from "vue";
import App from "./App.vue";
import Vuelidate from "vuelidate";
Vue.use(Vuelidate);
import router from "./router";
//import store from './store'

Vue.config.productionTip = false;
Vue.prototype.$_debounce = debounce;
Vue.prototype.$hammerMc = null;

new Vue({
  router,
  //store,
  render: h => h(App),
  data() {
    return {
      //env: 'dev',
      env: "prod",
      locale: "en",
      serverBase: {
        //dev: "http://localhost/hennaspeedy/personal-care-back-end",
        //prod: "https://henna.webdesign366.net"
        dev: "https://admin.hennaspeedy.com",
        prod: "https://admin.hennaspeedy.com"
      },
      siteBase: {
        dev: "http://localhost:8082",
        prod: "https://hennaspeedy.com"
      },
      cart: null,
      user: null,
      token: null,
      products: [],
      appLoading: false,
      showApp: false,
      loadingQueueSize: 0,
      checkout: null,
      msgBox: {
        message: "",
        alertType: "success"
      },
      fbAuthUi: null
    };
  },
  created() {
    this.initApp();
    this.loadProducts();
    //this.loadProductsStatic();

    this.$watch("loadingQueueSize", this.watchAppLoadingQueue, {
      deep: true,
      immediate: true
    });
  },
  methods: {
    siteRoot() {
      var baseurl = this.siteBase[this.env];
      return baseurl;
    },
    serverRoot() {
      var baseurl = this.serverBase[this.env];
      return baseurl;
    },
    serverRoute(name) {
      var baseurl = this.serverBase[this.env],
        routes = {
          media: "/",
          getProducts: "/wp-json/henna-speedy-api/v1/products",
          relatedProductsDetails:
            "/wp-json/henna-speedy-api/v1/related-products-details",
          contactUs: "/wp-json/henna-speedy-api/v1/contact-us",
          feedBack: "/wp-json/henna-speedy-api/v1/feed-back"
        };
      return baseurl + routes[name];
    },
    watchAppLoadingQueue(newVal) {
      if (newVal > 0) {
        this.appLoading = true;
        window.showLoading();
      } else if (newVal == 0) {
        this.appLoading = false;
        window.hideLoading();
      } else if (newVal < 0) {
        this.appLoading = false;
        this.loadingQueueSize = 0;
        window.hideLoading();
      }
    },
    initApp() {
      let me = this;
    },
    loadProducts() {
      let me = this;
      var settings = {
        async: false,
        crossDomain: true,
        url: me.$root.serverRoute("getProducts"),
        method: "GET",
        dataType: "json",
        data: {}
      };
      //this.$root.loadingQueueSize++;
      $.ajax(settings)
        .done(function(resp) {
          //me.$root.loadingQueueSize--;

          document.getElementById("app").style.display = "block";
          window.hideLoading();

          console.log(resp);
          if (resp.success == false) {
            alert("An error occurs on server when getting products");
          } else {
            resp.data.forEach(elt => {
              //elt.unitPrice = elt.sale_price;
              //elt.image = elt.images[0].src;
              elt.extra_data = me.getMetaData(elt.meta_data);
            });
            //console.log("products", resp.data);
            me.$root.products = resp.data;
          }
        })
        .fail(function(resp) {
          //me.$root.loadingQueueSize--;
          document.getElementById("app").style.display = "block";
          window.hideLoading();
          alert("An error occurs on server");
        });
    },
    loadProductsStatic() {
      let me = this;
      me.$root.loadingQueueSize++;
      let results = import(
        /* webpackChunkName: "lang-[request]" */ `@/data/products.json`
      ).then(resp => {
        console.log("loloadProductsStaticaded", data);
        let data = resp.default;
        data.forEach(elt => {
          //elt.unitPrice = elt.sale_price;
          //elt.image = elt.images[0].src;
          elt.extra_data = me.getMetaData(elt.meta_data);
        });
        //console.log("products", resp.data);
        me.$root.products = data;
        me.$root.loadingQueueSize--;
      });
    },
    getMetaData(data) {
      let result = {};
      data.forEach((item, index) => {
        if (item.key && item.value) {
          result[item.key] = item.value;
        }
      });
      return result;
    },
    initBody() {
      if (this.$route.name == "home") {
        $("body").css("overflow", "hidden");
      } else {
        $("body").css("overflow", "");
        $("body").css("overflow-y", "auto");
      }
    }
  }
}).$mount("#app");
